import { func, number, bool, shape, string, oneOfType } from "prop-types";
import { observer } from "mobx-react";
import { Checkbox, Label, MenuButton } from "@components";
import Grid from "@material-ui/core/Grid";

export const LabelSelectItem = observer(({
  isUsed,
  label,
  onAdd,
  onRemove,
  maxWidth=260
}) => {
  
  const { name } = label;
  
  const handleCheck = () => {
    if(isUsed)
      onRemove(label);
    else
      onAdd(label);
  }
  
  return (
    <Grid item container justifyContent="space-between" alignItems="center">
      <MenuButton
        icon={
          <Checkbox
            name={name}
            checked={isUsed}
          />
        }
        onClick={handleCheck}
      >
        <Label {...label} size="small" ellipsisOnOverflow maxWidth={maxWidth} />
      </MenuButton>
    </Grid>
  )
})

LabelSelectItem.propTypes = {
  isUsed: bool.isRequired,
  onAdd: func.isRequired,
  onRemove: func.isRequired,
  label: shape({
    id: oneOfType([number, string]).isRequired,
    systemId: number,
    name: string.isRequired,
    fontColor: string,
    backgroundColor: string
  }).isRequired,
  maxWidth: number,
}